import { AlertTriangle, FlaskConical, ShieldAlert, WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

export const AuthBanner = ({ health, auth, onSettings }) => {
  if (!health) return null;
  const st = health.auth_state;
  const stream = health.stream?.status;
  let cfg = null;
  if (st === "auth_required") {
    cfg = {
      icon: ShieldAlert, cls: "border-rose-800/60 bg-rose-950/40 text-rose-200", tid: "banner-auth-required",
      title: "Zerodha login required", body: auth?.reason || "The Kite session is not active. Live data is paused; last snapshots are marked stale.",
      action: "Log in via Settings",
    };
  } else if (st === "live_only") {
    cfg = {
      icon: ShieldAlert, cls: "border-rose-800/60 bg-rose-950/40 text-rose-200", tid: "banner-live-only",
      title: "Live-only mode — strict", body: "Simulated data is turned OFF. No prices, depth, candles or option chains are shown until a Zerodha session is active. Add keys and log in to see live data.",
      action: "Connect Zerodha",
    };
  } else if (st === "simulated") {
    cfg = {
      icon: FlaskConical, cls: "border-violet-800/50 bg-violet-950/30 text-violet-200", tid: "banner-simulated",
      title: "Simulated mode ON", body: health.allow_simulated && auth?.configured
        ? "You chose simulated data. All prices, depth, candles and option chains are SIMULATED. Your Zerodha session is kept — turn the header toggle off to switch to live data."
        : "No Zerodha keys configured. All prices, depth, candles and option chains are SIMULATED until you add keys and log in.",
      action: auth?.configured ? null : "Add Zerodha keys",
    };
  } else if (["reconnecting", "down", "connecting"].includes(stream)) {
    cfg = {
      icon: WifiOff, cls: "border-amber-800/60 bg-amber-950/40 text-amber-200", tid: "banner-stream-degraded",
      title: `Stream ${stream}`, body: `WebSocket is ${stream}. Reconnect attempts: ${health.stream.reconnects}. Snapshots may be stale.`,
    };
  } else if (st === "syncing" || st === "authenticating") {
    cfg = { icon: AlertTriangle, cls: "border-cyan-800/50 bg-cyan-950/30 text-cyan-200", tid: "banner-syncing",
      title: "Preparing live session", body: "Downloading the instrument master and connecting to Kite…" };
  }
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <div data-testid={cfg.tid} className={`rise flex flex-wrap items-center gap-3 rounded-md border px-4 py-3 ${cfg.cls}`}>
      <Icon className="h-5 w-5 shrink-0" />
      <div className="min-w-0 flex-1">
        <div className="font-display text-sm font-semibold">{cfg.title}</div>
        <div className="text-xs opacity-80">{cfg.body}</div>
      </div>
      {cfg.action && (
        <Button data-testid="banner-action-button" size="sm" onClick={onSettings} className="h-8 bg-slate-100 text-slate-900 hover:bg-white">
          {cfg.action}
        </Button>
      )}
    </div>
  );
};
